import { gql } from '@apollo/client'

export const ASSIGN_USERS_ACTIVE = gql`
  mutation AssignUsersActive($input: AssignUsersActiveInput!) {
    assignUsersActive(input: $input) {
      users {
        id
        isActive
      }
    }
  }
`
